import React, { useEffect } from 'react';
import locales from '../../../content.json';

import bg3_webp from './img/bg3.avif';
import bg3_jpg from './img/bg3.jpg';


import { analyticsEventsTracker, GTMOnboardingFunnelEvent, EVENT_TRACKERS } from '../../../utils/analytics';
import s from './index.module.scss';
import { getParameterFromURL } from '../../../utils/scripts';

export const MainScreenDogTranslator = () => {
  const subscrUK = getParameterFromURL('subscrUK');
  const version = subscrUK ? 'version2UK' : 'version2';

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.showPaywall(version), EVENT_TRACKERS.GTM);
  }, []);

  return (
    <div className={s.mainScreen}>
        <picture>
          <source srcSet={bg3_webp} type="image/avif" />
          <img src={bg3_jpg} alt="header image" />
        </picture>
        <h2 className={s.title} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_301 }} />
          
        <p
          className={s.subtitle}
          dangerouslySetInnerHTML={{
            __html: locales[window.userLang].payment_text_302,
          }}
        />
    </div>
  );
};
